module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/accounts-list/accounts-list.component.css
// module id = ./src/app/accounts/accounts-list/accounts-list.component.css
// module chunks = main